function convertToFormSchema(attributes) {
  const data = { status: false, validation: [] };
  Object.keys(attributes).forEach((attr) => {
    data.validation[attr] = {
      message: null,
      status: '',
      value: attributes[attr],
    };
  });
  return data;
}

export function injectFormState(formRules, attributes) {
  return {
    formRules,
    formSchema: convertToFormSchema(attributes),
  };
}

function setSuccessValidation(formSchema) {
  const schema = formSchema;
  const { validation } = schema;

  schema.status = true;

  Object.keys(validation).forEach((attr) => {
    validation[attr] = {
      status: 'success',
      message: null,
    };
  });

  return schema;
}

function setFailureValidation(formSchema, object, errors) {
  const schema = formSchema;
  const { validation } = schema;

  schema.status = false;

  Object.keys(validation).forEach((attr) => {
    if (object[attr] !== undefined) {
      if (errors[attr] === undefined) {
        validation[attr] = {
          status: 'success',
          message: null,
        };
      } else {
        validation[attr] = {
          status: 'error',
          message: errors[attr],
        };
      }
    }
  });

  return schema;
}

function validate(schema, options, object, formSchema) {
  const opts = Object.assign(
    {
      abortEarly: false,
      stripUnknown: true,
    },
    options,
  );

  return schema
    .validate(object, opts)
    .then(() => setSuccessValidation(formSchema))
    .catch((data) => {
      const errors = {};
      data.inner.forEach((error) => {
        errors[error.path] = error.message;
      });

      return setFailureValidation(formSchema, object, errors);
    });
}

export function formValidate(object) {
  return validate(
    this.state.formRules,
    {},
    object,
    this.state.formSchema,
  ).then((formSchema) => {
    this.setState({ formSchema });
    return formSchema;
  });
}

export function onChangeFieldText(event) {
  const element = event.target;
  const field = { [element.name]: element.value };
  const validationOnChange = JSON.parse(
    element.getAttribute('data-validation-onchange'),
  );

  this.setState({
    attributes: Object.assign(this.state.attributes, field),
  });

  if (validationOnChange !== false) {
    this.formValidate(field);
  }
}

export function onBlurFieldText(event) {
  const element = event.target;
  this.formValidate({ [element.name]: element.value.trim() });
}



// WEBPACK FOOTER //
// ./src/utils/form.js